<template>
  <div class="reimbursement-container">
    <div class="page-header">
      <h2>报销管理</h2>
      <p>管理公司报销申请信息</p>
    </div>
    
    <div class="content-area">
      <el-card>
        <template #header>
          <div class="card-header">
            <span>报销列表</span>
            <div class="header-actions">
              <el-button type="primary" size="small" @click="handleAdd">新建报销</el-button>
              <el-button type="success" size="small" @click="handleRefresh">刷新数据</el-button>
            </div>
          </div>
        </template>
        
        <!-- 搜索区域 -->
        <div class="search-area">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="报销名称">
              <el-input v-model="searchForm.reimbursement_name" placeholder="请输入报销名称" clearable />
            </el-form-item>
            <el-form-item label="费用类别">
              <el-select v-model="searchForm.expense_category" placeholder="请选择费用类别" style="width: 200px;" clearable>
                <el-option label="差旅费" value="差旅费" />
                <el-option label="交通费" value="交通费" />
                <el-option label="餐饮费" value="餐饮费" />
                <el-option label="办公用品" value="办公用品" />
                <el-option label="通讯费" value="通讯费" />
                <el-option label="其他" value="其他" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 报销列表 -->
        <el-table
          :data="reimbursementList"
          v-loading="loading"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" />
          <el-table-column prop="reimbursement_name" label="报销名称" width="180" show-overflow-tooltip />
          <el-table-column prop="reimbursement_amount" label="报销金额" width="120" align="right">
            <template #default="scope">
              ¥{{ formatAmount(scope.row.reimbursement_amount) }}
            </template>
          </el-table-column>
          <el-table-column prop="expense_category" label="费用类别" width="120" />
          <el-table-column prop="reimbursement_time" label="报销时间" width="180">
            <template #default="scope">
              {{ formatDateTime(scope.row.reimbursement_time) }}
            </template>
          </el-table-column>
          <el-table-column prop="expense_description" label="费用说明" show-overflow-tooltip />
          <el-table-column prop="createtime" label="创建时间" width="180">
            <template #default="scope">
              {{ formatDate(scope.row.createtime) }}
            </template>
          </el-table-column>
          <el-table-column prop="updatetime" label="更新时间" width="180">
            <template #default="scope">
              {{ formatDate(scope.row.updatetime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template #default="scope">
              <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-area">
          <el-pagination
            v-model:current-page="pagination.currentPage"
            v-model:page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </el-card>
    </div>

    <!-- 添加/编辑报销对话框 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      width="700px"
      @close="handleDialogClose">
      <el-form
        ref="reimbursementFormRef"
        :model="reimbursementForm"
        :rules="reimbursementRules"
        label-width="100px">
        <el-form-item label="报销名称" prop="reimbursement_name">
          <el-input v-model="reimbursementForm.reimbursement_name" placeholder="请输入报销名称" />
        </el-form-item>
        <el-form-item label="报销金额" prop="reimbursement_amount">
          <el-input-number
            v-model="reimbursementForm.reimbursement_amount"
            :min="0"
            :precision="2"
            :step="0.01"
            placeholder="请输入报销金额"
            style="width: 100%" />
        </el-form-item>
        <el-form-item label="费用类别" prop="expense_category">
          <el-select v-model="reimbursementForm.expense_category" placeholder="请选择费用类别" style="width: 100%">
            <el-option label="差旅费" value="差旅费" />
            <el-option label="交通费" value="交通费" />
            <el-option label="餐饮费" value="餐饮费" />
            <el-option label="办公用品" value="办公用品" />
            <el-option label="通讯费" value="通讯费" />
            <el-option label="其他" value="其他" />
          </el-select>
        </el-form-item>
        <el-form-item label="报销时间" prop="reimbursement_time">
          <el-date-picker
            v-model="reimbursementForm.reimbursement_time"
            type="datetime"
            placeholder="请选择报销时间"
            style="width: 100%"
            value-format="YYYY-MM-DD HH:mm:ss" />
        </el-form-item>
        <el-form-item label="费用说明">
          <el-input
            v-model="reimbursementForm.expense_description"
            type="textarea"
            :rows="3"
            placeholder="请输入费用说明" />
        </el-form-item>
        <el-form-item label="报销票据">
          <el-upload
            ref="uploadRef"
            class="upload-demo"
            :action="uploadUrl"
            :headers="headers"
            :data="uploadData"
            :file-list="fileList"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :on-remove="handleFileRemove"
            :before-upload="beforeUpload"
            multiple
            :limit="5"
            accept=".jpg,.jpeg,.png,.pdf">
            <el-button type="primary">上传票据</el-button>
            <template #tip>
              <div class="el-upload__tip">
                支持上传 JPG、PNG、PDF 格式文件，单个文件不超过 5MB
              </div>
            </template>
          </el-upload>
          <div v-if="reimbursementForm.reimbursement_invoice" class="current-files">
            <div class="file-title">已上传票据：</div>
            <div class="file-items">
              <el-tag
                v-for="(file, index) in getFileList(reimbursementForm.reimbursement_invoice)"
                :key="index"
                closable
                @close="handleRemoveFile(file, index)"
                class="file-tag"
                @click="handleFilePreview(file)">
                {{ getFileName(file) }}
              </el-tag>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'ReimbursementPage',
  data() {
    return {
      loading: false,
      reimbursementList: [],
      selectedReimbursements: [],
      searchForm: {
        reimbursement_name: '',
        expense_category: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新建报销',
      submitting: false,
      reimbursementForm: {
        id: '',
        reimbursement_name: '',
        reimbursement_amount: 0,
        reimbursement_invoice: '',
        reimbursement_time: '',
        expense_category: '',
        expense_description: ''
      },
      reimbursementRules: {
        reimbursement_name: [
          { required: true, message: '请输入报销名称', trigger: 'blur' },
          { min: 2, max: 255, message: '报销名称长度在 2 到 255 个字符', trigger: 'blur' }
        ],
        reimbursement_amount: [
          { required: true, message: '请输入报销金额', trigger: 'blur' },
          { type: 'number', min: 0, message: '报销金额必须大于等于0', trigger: 'blur' }
        ],
        expense_category: [
          { required: true, message: '请选择费用类别', trigger: 'change' }
        ],
        reimbursement_time: [
          { required: true, message: '请选择报销时间', trigger: 'change' }
        ]
      },
      // 文件上传相关
      uploadUrl: 'https://erp.dynamic365.cn/api/common/upload',
        headers: {
        'token': localStorage.getItem('token')
      },
      uploadData: {
        type: 'reimbursement'
      },
      fileList: []
    }
  },
  computed: {
    reimbursementFormRef() {
      return this.$refs.reimbursementFormRef
    }
  },
  mounted() {
    this.getReimbursementList()
  },
  methods: {
    // 获取报销列表
    async getReimbursementList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        
        const response = await this.$axios.get('/api/reimbursement/getlist', { params })
        if (response.code === 1) {
          this.reimbursementList = response.data || []
          this.pagination.total = response.total || 0
        } else {
          ElMessage.error(response.msg || '获取报销列表失败')
        }
      } catch (error) {
        console.error('获取报销列表失败:', error)
        ElMessage.error('获取报销列表失败')
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.getReimbursementList()
    },

    // 重置搜索
    handleReset() {
      this.searchForm = {
        reimbursement_name: '',
        expense_category: ''
      }
      this.pagination.currentPage = 1
      this.getReimbursementList()
    },

    // 新建报销
    handleAdd() {
      this.dialogTitle = '新建报销'
      this.reimbursementForm = {
        id: '',
        reimbursement_name: '',
        reimbursement_amount: 0,
        reimbursement_invoice: '',
        reimbursement_time: '',
        expense_category: '',
        expense_description: ''
      }
      this.fileList = []
      this.dialogVisible = true
    },

    // 编辑报销
    handleEdit(row) {
      this.dialogTitle = '编辑报销'
      this.reimbursementForm = { ...row }
      // 将金额转换为数字类型
      this.reimbursementForm.reimbursement_amount = parseFloat(row.reimbursement_amount) || 0
      this.fileList = this.getFileList(row.reimbursement_invoice).map(file => ({
        name: this.getFileName(file),
        url: file
      }))
      this.dialogVisible = true
    },

    // 删除报销
    async handleDelete(row) {
      try {
        await ElMessageBox.confirm(
          `确定要删除报销 "${row.reimbursement_name}" 吗？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
        
        const response = await this.$axios.post('/reimbursement/delete', { id: row.id })
        if (response.code === 1) {
          ElMessage.success('删除成功')
          this.getReimbursementList()
        } else {
          ElMessage.error(response.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除报销失败:', error)
          ElMessage.error('删除失败')
        }
      }
    },

    // 刷新数据
    handleRefresh() {
      this.getReimbursementList()
      ElMessage.success('数据已刷新')
    },

    // 提交表单
    async handleSubmit() {
      if (!this.reimbursementFormRef) return

      try {
        await this.reimbursementFormRef.validate()
        this.submitting = true

        let response
        if (this.reimbursementForm.id) {
          // 编辑报销
          response = await this.$axios.post('/reimbursement/edit', this.reimbursementForm)
        } else {
          // 新建报销
          response = await this.$axios.post('/reimbursement/add', this.reimbursementForm)
        }

        if (response.code === 1) {
          ElMessage.success(this.reimbursementForm.id ? '编辑成功' : '新建成功')
          this.dialogVisible = false
          this.getReimbursementList()
        } else {
          ElMessage.error(response.msg || '操作失败')
        }
      } catch (error) {
        if (error.response) {
          ElMessage.error(error.response.msg || '操作失败')
        }
      } finally {
        this.submitting = false
      }
    },

    // 对话框关闭
    handleDialogClose() {
      this.reimbursementFormRef?.resetFields()
      this.fileList = []
    },

    // 选择报销
    handleSelectionChange(selection) {
      this.selectedReimbursements = selection
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.currentPage = 1
      this.getReimbursementList()
    },

    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.getReimbursementList()
    },

    // 格式化金额
    formatAmount(amount) {
      if (!amount) return '0.00'
      return parseFloat(amount).toFixed(2)
    },

    // 格式化日期时间
    formatDateTime(datetime) {
      if (!datetime) return '-'
      return datetime
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },

    // 将文件字符串转换为数组
    getFileList(fileString) {
      if (!fileString) return []
      return fileString.split(',').filter(file => file.trim())
    },

    // 获取文件名
    getFileName(filePath) {
      if (!filePath) return ''
      const parts = filePath.split('/')
      return parts[parts.length - 1]
    },

    // 文件预览
    handleFilePreview(file) {
      window.open(file, '_blank')
    },

    // 文件上传前验证
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        ElMessage.error('文件大小不能超过 5MB!')
        return false
      }
      return true
    },

    // 文件上传成功
    handleUploadSuccess(response, file) {
      if (response.code === 1) {
        // 将新文件添加到文件列表中
        const newFile = response.data.url || response.data.path
        const currentFiles = this.reimbursementForm.reimbursement_invoice ? this.reimbursementForm.reimbursement_invoice.split(',') : []
        currentFiles.push(newFile)
        this.reimbursementForm.reimbursement_invoice = currentFiles.join(',')
        
        ElMessage.success('文件上传成功')
      } else {
        ElMessage.error(response.msg || '文件上传失败')
      }
    },

    // 文件上传失败
    handleUploadError(error, file) {
      console.error('文件上传失败:', error)
      ElMessage.error('文件上传失败')
    },

    // 移除文件
    handleFileRemove(file, fileList) {
      // 从文件列表中移除
      const currentFiles = this.reimbursementForm.reimbursement_invoice ? this.reimbursementForm.reimbursement_invoice.split(',') : []
      const fileIndex = currentFiles.findIndex(f => f === file.url || f === file.response?.data?.url)
      if (fileIndex > -1) {
        currentFiles.splice(fileIndex, 1)
        this.reimbursementForm.reimbursement_invoice = currentFiles.join(',')
      }
    },

    // 移除已上传文件
    handleRemoveFile(file, index) {
      const currentFiles = this.reimbursementForm.reimbursement_invoice ? this.reimbursementForm.reimbursement_invoice.split(',') : []
      currentFiles.splice(index, 1)
      this.reimbursementForm.reimbursement_invoice = currentFiles.join(',')
    }
  }
}
</script>

<style scoped>
.reimbursement-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  color: #303133;
}

.page-header p {
  margin: 5px 0 0 0;
  color: #909399;
  font-size: 14px;
}

.content-area {
  margin-top: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.search-area {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.pagination-area {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.current-files {
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.file-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
}

.file-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.file-tag {
  margin: 2px;
  cursor: pointer;
}

.file-tag:hover {
  opacity: 0.8;
}

.upload-demo {
  width: 100%;
}
</style>
